"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VictoryTooltip = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNativeSvg = require("react-native-svg");
var _es = require("victory-tooltip/es");
var _victoryLabel = require("./victory-label");
var _victoryPortal = require("./victory-portal/victory-portal");
var _flyout = require("./victory-primitives/flyout");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class VictoryTooltip extends _es.VictoryTooltip {
  static defaultProps = {
    ..._es.VictoryTooltip.defaultProps,
    labelComponent: /*#__PURE__*/_react.default.createElement(_victoryLabel.VictoryLabel, null),
    flyoutComponent: /*#__PURE__*/_react.default.createElement(_flyout.Flyout, null),
    groupComponent: /*#__PURE__*/_react.default.createElement(_reactNativeSvg.G, null)
  };
  static defaultEvents() {
    return [{
      target: "data",
      eventHandlers: {
        onPressIn: targetProps => {
          return [{
            target: "labels",
            mutation: () => ({
              active: true
            })
          }, {
            target: "data",
            mutation: () => targetProps.activateData ? {
              active: true
            } : {
              active: undefined
            }
          }];
        },
        onPressOut: () => {
          return [{
            target: "labels",
            mutation: () => ({
              active: undefined
            })
          }, {
            target: "data",
            mutation: () => ({
              active: undefined
            })
          }];
        }
      }
    }];
  }
  renderTooltip(props) {
    const evaluatedProps = this.getEvaluatedProps(props);
    const {
      flyoutComponent,
      labelComponent,
      groupComponent,
      active,
      renderInPortal
    } = evaluatedProps;
    if (!active) {
      return renderInPortal ? /*#__PURE__*/_react.default.createElement(_victoryPortal.VictoryPortal, null, /*#__PURE__*/_react.default.createElement(_reactNativeSvg.G, null)) : /*#__PURE__*/_react.default.createElement(_reactNativeSvg.G, null);
    }
    const calculatedValues = this.getCalculatedValues(evaluatedProps);
    const children = [/*#__PURE__*/_react.default.cloneElement(flyoutComponent, this.getFlyoutProps(evaluatedProps, calculatedValues)), /*#__PURE__*/_react.default.cloneElement(labelComponent, this.getLabelProps(evaluatedProps, calculatedValues))];
    const tooltip = /*#__PURE__*/_react.default.cloneElement(groupComponent, {
      role: "presentation"
    }, children);
    return renderInPortal ? /*#__PURE__*/_react.default.createElement(_victoryPortal.VictoryPortal, null, tooltip) : tooltip;
  }
}
exports.VictoryTooltip = VictoryTooltip;